Bu sayfadaki puf noktalar: 1 - Gruplar -> AlgrupUrunler -> Urunler seklinde yapi
2 - AltgrupUrunler-de herhangi bir altgrupa tikladiktan sonra gelecek olan
UrunlerPage-in child-i 3 - params ile AltgrupUrunler-den 'params.altg_ad' gibi
veriler geliyor 4 - mounted kullanildi. sayfa scroll oldugu zaman 'sayfa konum
bar'in gorunmesi ya da gizlenmesinin tetiklenmesi icin 5 - diger gerekli
detaylar yorum satirlari ile belirtildi zaten
<template>
  <div v-cloak>
    <!-- {{geciciSepet}} -->
    <SepetButton />
    <div class="row m-4">
      <div class="col-md-1"></div>
      <div class="col-lg-10 col-md-12">
        <div style="display: flex; flex-direction: column">
          <div v-if="showYukleniyor" class="col-lg-3 col-sm-12 col-12 col-md-3">
            <div class="card skeleton-card sticky"></div>
          </div>

          <!------------ kampanya start ------------->
          <div style="width: 100%">
            <div class="kampanya-container">
              <img
                :src="
                  kampanyaimage2 +
                  kampanya.id +
                  '.jpg' +
                  '?' +
                  kampanya.imageupdate
                "
                class="kampanya-resim"
              />
              <div
                style="
                  height: 100%;
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: start;
                  align-items: start;

                "
              >
                <div
                  class="kampanya-metin"
                  style="text-align: start; padding: 4px"
                  v-html="kampanya.ad"
                ></div>
                <div
                  class="kampanya-aciklama mt-2"
                  style="
                    text-align: start;
                    height: 100%;
                    padding: 4px;

                  "
                  v-html="kampanya.aciklama"
                ></div>
              </div>
            </div>
          </div>
          <div class="mt-2" style="justify-content: center; display: block">
            <!-- urunler start -->
            <div
              v-for="liste in altgrupUrunler"
              :key="liste.id"
              class="float-left urunler-mobile col-lg-3 col-sm-6 col-md-3"
            >
              <div>
                <div
                  class="card mb-3 urunler-col"
                  :style="altgrupUrunlerShadow"
                >
                  <router-link
                    :to="{
                      name: 'UrunPage',
                      params: {
                        urun_ad: liste.ad,
                        g_id: liste.grup,
                        g_ad: liste.grupad,
                        altg_id: liste.altgrup,
                        altg_ad: liste.altgrupad,
                      },
                    }"
                  >
                    <div class="zoom flex-center max-width-img">
                      <img
                        v-if="liste.barkod.length < 8"
                        class="img-fluid w-100 first"
                        :src="
                          imagecompany +
                          ushp +
                          '/' +
                          liste.barkod +
                          '.jpeg?' +
                          liste.imageupdate
                        "
                        alt=""
                      />
                      <img
                        v-else
                        class="img-fluid w-100 first"
                        :src="
                          image + liste.barkod + '.jpeg?' + liste.imageupdate
                        "
                        alt=""
                      />
                    </div>
                  </router-link>
                  <router-view />
                  <IndirimYazisi
                    :urun="liste"
                    v-if="
                      liste.kampanyalimi == 1 &&
                      liste.satisfiyat < liste.kampanyasizsatisfiyat
                    "
                  />
                  <div class="card-body text-center" :style="altgrupUrunleer">
                    <h6 class="min-height-name">{{ liste.ad }}</h6>
                    <hr style="background-color: white" />
                    <h6 class="mb-3">
                      <span class="priceText"
                        >{{ parseFloat(liste.satisfiyat).toFixed(2) }} ₺</span
                      >
                      <span
                        v-if="
                          liste.kampanyalimi == 1 &&
                          liste.satisfiyat < liste.kampanyasizsatisfiyat
                        "
                        class="ml-1 text-grey"
                        ><s>{{ liste.kampanyasizsatisfiyat }} ₺</s></span
                      >
                    </h6>
                    <div class="urunler-adet-input">
                      <AdetInputveSepeteEkleButton :liste="liste" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</template>
<script>
import SepetButton from "@/components/SepetButton";
import AdetInputveSepeteEkleButton from "@/components/AdetInputveSepeteEkleButton";
import IndirimYazisi from "@/components/IndirimYazisi";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  components: {
    SepetButton,
    AdetInputveSepeteEkleButton,
    IndirimYazisi,
  },
  data() {
    return {
      altgrupUrunler: [], // fetchKampanyaUrunler() sorgusu sonrasi donen bilgileri bu array-e atilip, sonrasindaki tum urunler bu array uzerinden listeleniyor
      errors: [], // hata olursa buraya doner
      // UrunSayiFiltreleme emit-ten gelen bilgi ayni zamanda dahaFazlaGoster yazilir, urun filtrelemede kullanilir
      dahaFazlaGoster: 32, // daha fazla goster butonu icin. ilk degeri 30 verildi. Ve sayfa render edildiginde 30 urun listeler. Sonrasinda her "daha fazla goster" butonuna tiklanildigi anda fazlaGoster() fonksiyonu calisir
      showSayfaKonum: true, // 'Ana sayfa > Et/Tavuk > Kirmizi Et' navigasyon barinin show/hide-i icin
      lastScrollPosition: 0, // son scroll konumu icin
      showYukleniyor: true, // sorgu beklenene kadar ki sure zarfinda gorunecek loading svg show/hide-i icin
      showUrunGruplari: false,
      showUrunlerBar: false,
      // xgruplar: [],
      // cookie bilgileri START
      udep: "",
      ushp: "",
      // cookie bilgileri END
      loadMore: true,
      kampanya: "",
    };
  },
  computed: {
    ...mapGetters([
      "image",
      "imagecompany",
      "kampanyaimage2",
      "urunGruplariColor",
      "urunGruplari",
      "urunGruplariBaslik",
      "altgrupUrunlerBar",
      "altgrupUrunleer",
      "altgrupUrunlerShadow",
      "dahaFazlaGosterButton",
      "serverRequest",
      "urunGruplariEach",
    ]),
  },
  methods: {
    getUid_Udep() {
      this.udep = this.decryptCookie("udep");
      this.ushp = this.decryptCookie("ushp");
    },
    async fetchKampanyaUrunler() {
      this.getUid_Udep();
      try {
        const formData = new FormData();
        formData.append("f", "get_kampanyalar_data");
        formData.append("depo", "1");
        formData.append("deposahip", "1");
        const response = await axios.post(this.serverRequest, formData, {
          headers: {
            // 'Accept': 'application/json',
            // "Access-Control-Allow-Origin": "*",
            // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        });
        // this.altgrupUrunler = response.data[1].kampanyadetay;

        this.kampanya = response.data.find(
          (element) => element.id == this.$route.params.k_id
        );

        this.altgrupUrunler = this.kampanya.kampanyadetay;
      } catch (error) {
        this.errors.push(error); // hata mesajlari data() icerisinde de tanimlanan error array-ine yazilir
      }
      if (this.altgrupUrunler) {
        this.showYukleniyor = false;
        this.showUrunGruplari = true; // skeletor loader-i gittikten sonra gorunmesi icin
        this.showUrunlerBar = true; // skeletor loader-i gittikten sonra gorunmesi icin
      }
    },
  },
  created() {
    this.fetchKampanyaUrunler(); // sayfa render oldugunda request yapilir ve urunler listelenir
  },
};
</script>
<style scoped>
[v-cloak] > * {
  display: none;
}
@media (max-width: 990px) {
  #dahaFazlaID {
    margin-bottom: 40px;
  }
}
/* iPad */
@media (max-width: 780px) {
  .resp-urun-baslik {
    font-size: 15px;
  }
  .urun-gruplari-each {
    font-size: 12px !important;
  }
  .resp-urun-button {
    font-size: 8px;
  }
}
@media (max-width: 500px) {
  .text-danger {
    font-size: 13px;
  }
  .text-grey {
    font-size: 13px;
  }
}
.kampanya-container {
  padding: 8px;
  align-items: center;
  background-color: wheat;
  border: 4px;
  border-radius: 12px;
  border-color: black;
  height: 100%;
  display: flex;
  flex-direction: row;
}

@media (max-width: 400px) {
  .page-bar {
    font-size: 11px;
  }
  .min-height-name {
    font-size: 12px;
    min-height: 26px !important;
    max-height: 26px !important;
  }

  .urunler-col {
    margin-left: -10px;
    margin-right: -10px;
  }
}
/* iPhone 5/SE */
@media (max-width: 320px) {
  .urunler-mobile .float-left {
    padding: 10px;
  }
  .row .urunler-mobile {
    margin-left: -24px;
    margin-right: -24px;
  }
  .urunler-col {
    margin-left: -7px;
    margin-right: -7px;
  }
}

.deneme {
  max-width: 20%;
}
.kampanya-resim {
  max-height: 100%;
  max-width: 50%;
}

@media (max-width: 780px) {
  .kampanya-resim {
    max-height: 100%;
    max-width: 100%;
  }
  .kampanya-container {
    flex-direction: column;
  }
}
.cardwidth {
  flex: 0 0 50%;
  max-width: 50%;
}

@media (min-width: 576px) {
  .cardwidth {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 768px) {
  .cardwidth {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

@media (min-width: 992px) {
  .cardwidth {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.resp-urun-button {
  border-radius: 10px;
}
.urunler-col {
  margin-left: -5px;
  margin-right: -5px;
  height: 420px;
}
.urun-gruplari-baslik {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  padding: 22px 0px 22px 0px;
}
.grup-basliklari-body {
  border-radius: 10px;
}
.sayfa-konum-hidden {
  display: none;
  transform: translate3d(0, -100%, 0);
}
h5 {
  padding-top: 8px;
}
.sticky {
  z-index: 8;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 2px;
}
.sticky-sayfa-konum {
  z-index: 5;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 80px;
  padding-left: 15px;
  padding-right: 15px;
}
.min-height-name {
  margin-top: -5px;
  min-height: 60px;
  max-height: 60px;
  overflow: hidden !important;
  white-space: normal;
  font-size: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-family: "Konkhmer Sleokchher", sans-serif;
}
.priceText {
  font-family: "Roboto", sans-serif;
  font-size: 21px;
  font-weight: 500;
  color: #4b4b4b;
}
.float-left {
  display: inline;
  float: left;
}
img.first {
  max-width: 160px;
  max-height: 160px;
  object-fit: contain;
}
.max-width-img {
  min-height: 180px;
  max-height: 180px;
}
.daha-fazla {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 2px;
  padding: 5px 10px;
}
.urun-gruplari-baslik {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: 22px 0px 22px 0px;
}
.page-bar-div {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  font-size: 13px;
  color: #c4c4c4;
  background-color: white;
  padding: 15px;
  margin-top: 5px;
  overflow-x: auto; /* bar-in x ekseninde scroll-u icin */
  white-space: nowrap; /* bar-in x ekseninde scroll-u icin */
}
.page-bar {
  border: 1px solid;
  border-radius: 5px;
  padding: 10px;
  color: #c4c4c4;
}
.page-bar:hover {
  color: #318817;
}
.loading {
  width: 17px;
  height: 17px;
}
.urunler-adet-input {
  padding-left: 8px;
  display: flex;
  justify-content: center;
}
.baslik-dark {
  background-color: #212121;
  color: white;
}
.spinner {
  width: 45px;
  height: 45px;
}
.yukleniyor {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #616161;
}
/* skeleton loader START */

.kampanya-metin {
  font-size: 18px;
  font-family: "Konkhmer Sleokchher", sans-serif;
}
.kampanya-aciklama{
  font-size: 16px;
}
.skeleton-card {
  height: 250px;
  background-image: linear-gradient(#ccc, #ccc), linear-gradient(#ccc, #ccc),
    linear-gradient(#ccc, #ccc), linear-gradient(#ccc, #ccc),
    linear-gradient(#ccc, #ccc), linear-gradient(white, white);
  background-size: 120px 25px, 160px 20px, 100px 15px, 100px 15px, 120px 30px,
    190px 20px, 100% 100%;
  background-position: 50% 24px, 50% 85px, 50% 120px, 50% 146px, 50% 200px, 0 0;
  background-repeat: no-repeat;
  overflow: hidden;
}
.skeleton-card::before {
  /* div uzerindeki tarama efekti icin */
  content: "";
  display: block;
  position: absolute;
  left: -30px;
  top: 0;
  height: 100%;
  width: 50px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #e8e8e8 50%,
    transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -10px;
  }
  to {
    left: 100%;
  }
}
.skeleton-card-urunler {
  height: 365px;
  background-image: radial-gradient(circle 35px, #ccc 100%, transparent),
    linear-gradient(#ccc, #ccc), linear-gradient(#ccc, #ccc),
    linear-gradient(#ccc, #ccc), linear-gradient(#ccc, #ccc),
    linear-gradient(#ccc, #ccc), linear-gradient(#ccc, #ccc),
    linear-gradient(#ccc, #ccc), linear-gradient(white, white);
  background-size: 75px 75px, 25% 15px, 14% 15px, 20% 15px, 90% 1px, 30% 15px,
    75% 32px, 75% 32px, 100% 100%;
  background-position: 50% 44px, 20% 180px, 50% 180px, 75% 180px, 50% 220px,
    50% 245px, 50% 280px, 50% 320px, 0 0;
  background-repeat: no-repeat;
  overflow: hidden;
}
.skeleton-card-urunler::before {
  /* div uzerindeki tarama efekti icin */
  content: "";
  display: block;
  position: absolute;
  left: -30px;
  top: 0;
  height: 100%;
  width: 50px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #e8e8e8 50%,
    transparent 100%
  );
  animation: load-urunler 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load-urunler {
  from {
    left: -10px;
  }
  to {
    left: 100%;
  }
}
/* skeleton loader END */
.card {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  box-shadow: 0 0px rgba(0, 0, 0, 0.2);
}
</style>
